// extracted by mini-css-extract-plugin
export default {"myServices":"MyServices_myServices__Eel0P","myServicesBlock":"MyServices_myServicesBlock__9a7YH"};